import React, { useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import { TextField, InputLabel, Select, MenuItem, FormControl, Tooltip, IconButton} from "@mui/material"
import HelpCenter from '@mui/icons-material/HelpCenter';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import DoneIcon from '@mui/icons-material/Done';

import useAxiosProtect from "../../../../hooks/useAxiosProtect";

const GasModal = props => {

    const axiosProtect = useAxiosProtect();

    const site_id = parseInt(window.location.href.split('/').slice(-1))
    const utilityType = "gas";
    const [year, setYear] = useState('');
    const [month, setMonth] = useState('');
    const [units, setUnits] = useState('m3');
    const [gas, setGas] = useState('');
    const [gasCost, setGasCost] = useState('');
    const [invoice, setInvoice] = useState('');
    const [hdd, setHdd] = useState('');
    const [currencies, setCurrencies] = useState('cad');
    const [page, setPage] = useState(1);

    const [yearErr, setYearErr] = useState('');
    const [monthErr, setMonthErr] = useState('');
    const [invoiceErr, setInvoiceErr] = useState('');
    const [gasErr, setGasErr] = useState('');
    
    const handleYear = (event) => setYear(event.target.value);
    const handleMonth = (event) => setMonth(event.target.value);
    const handleUnits = (event) => {
        setUnits(event.target.value );
    };
    const handleGas = (event) => setGas(event.target.value);
    const handleGasCost = (event) => setGasCost(event.target.value);
    const handleHdd = (event) => setHdd(event.target.value);
    const handleInvoice = (event) => setInvoice(event.target.value);
    const handleCurrencies = (event) => {
            setCurrencies(event.target.value );
    };

    const costTip = 'If N/A or unknown, enter 0.';
    const monthTip = 'Choose the closet month to the metering period and ensure consistency';

    useEffect(() => {
        if (props.reading.id) {
            setYear(props.reading.year || '');
            setMonth(props.reading.month || '');
            setUnits(props.reading.gas_units || 'm3');
            setGas(props.reading.total_gas || '');
            setGasCost(props.reading.gas_cost || '');
            setInvoice(props.reading.total_bill_cost || '');
            setHdd(props.reading.hdd_18c || '');
            setCurrencies(props.reading.currency || 'cad');
        } 
    },[props.reading]);
    const createOrUpdateUtilityReading = async () => {
        try {

            let response;
            
            if (props.reading.id) {
                const payload = {
                    site_id: site_id,
                    gas_units: units,
                    total_gas: parseFloat(gas),
                    gas_cost: parseFloat(gasCost),
                    total_bill_cost: parseFloat(invoice),
                    month: parseInt(month),
                    year: parseInt(year),
                    hdd_18c: parseInt(hdd),
                    start_date: "2024-04-01",
                    end_date: "2024-05-02",
                };

                
                response = await axiosProtect.put(`/u/utilities?utilityType=${utilityType}&id=${props.reading.id}`, payload);

            }else {
                const payload = {
                    site_id: site_id,
                    gas_units: units,
                    total_gas: parseFloat(gas),
                    gas_cost: parseFloat(gasCost),
                    total_bill_cost: parseFloat(invoice),
                    month: parseInt(month),
                    year: parseInt(year),
                    start_date: "2024-04-01",
                    end_date: "2024-05-02",
                };

                response = await axiosProtect.post(`/u/utilities?utilityType=${utilityType}`, payload);
                props.onReadingCreated(response.data);
            }
            
            
            
            
            
            
            if (props.reading.id) {
                console.log(props.reading.id)
                
               
            }else {
               
            }
            // Create a new reading
            
            
    
            console.log("Success:", response.data);
            console.log(response.data.newRecord)
            props.onClose(); // Close the modal on success
    
        } catch (err) {
            console.error("Error:", err.response?.data || err.message);
        }
    };

    const validateInitPage = () => {
            let isValid = true;
            if (year === '') {
                setYearErr('Invalid year');
                isValid = false;
            }

            if (month === '') {
                setMonthErr('Invalid month');
                isValid = false;
            }

            if (invoice === '') {
                setInvoiceErr('Invalid Invoice');
                isValid = false;
            }
            return isValid;
        }

    const validateSecondPage = () => {
            let isValid = true;
            if (gas === '') {
                setGasErr('Invalid gas reading');
                isValid = false;
            }
            return isValid;
    }
  
    const incrementPage = () => {
        if(page === 1 && validateInitPage()){
            setPage(page + 1);
        }else if(page === 2 && validateSecondPage()){
            createOrUpdateUtilityReading()
        }
    }
    
    return (
        <Modal 
            show={true} 
            onHide={props.onClose} 
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <Modal.Title>{props.reading.id ? 'Update Gas Utility Readings' : 'Add Gas Utility Readings'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                {page === 1 &&
                <>
                <TextField fullWidth id="outlined-basic" label="Year" type="number" variant="outlined" 
                    value={year} 
                    onChange={handleYear} 
                    error={yearErr !== ''}
                    helperText={yearErr}
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                <div className="field-row-full-mb">
                    <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                        <InputLabel id="demo-simple-select-label">Month</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            defaultValue="m3"
                            error={monthErr !== ''}
                            helperText={monthErr}
                            label="Month"
                            value={month}
                            onChange={handleMonth}
                            MenuProps={{ disablePortal: true }}
                        >
                            <MenuItem value={1}>January</MenuItem>
                            <MenuItem value={2}>February</MenuItem>
                            <MenuItem value={3}>March</MenuItem>
                            <MenuItem value={4}>April</MenuItem>
                            <MenuItem value={5}>May</MenuItem>
                            <MenuItem value={6}>June</MenuItem>
                            <MenuItem value={7}>July</MenuItem>
                            <MenuItem value={8}>August</MenuItem>
                            <MenuItem value={9}>September</MenuItem>
                            <MenuItem value={10}>October</MenuItem>
                            <MenuItem value={11}>November</MenuItem>
                            <MenuItem value={12}>December</MenuItem>
                        </Select>
                    </FormControl>
                    <Tooltip title={monthTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                <div className="field-row-full-mb">
                <TextField fullWidth id="outlined-basic" label="Total Invoice Cost ($)" 
                    type="number" 
                    variant="outlined" 
                    error={invoiceErr !== ''}
                    helperText={invoiceErr}
                    value={invoice} 
                    onChange={handleInvoice} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                
                
                <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                    <InputLabel id="demo-simple-select-label">Currency</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="cad"
                        label="Currency"
                        value={currencies}
                        onChange={handleCurrencies}
                        MenuProps={{ disablePortal: true }}
                    >
                        <MenuItem value="cad">CAD</MenuItem>
                        <MenuItem value="usd">USD</MenuItem>
                        <MenuItem value="mex">Mex$</MenuItem>
                        <MenuItem value="gdp">GBP</MenuItem>
                        <MenuItem value="eur">EUR</MenuItem>
                    </Select>
                </FormControl>
                </>
            }
                {page === 2 &&
                <>
                 <FormControl fullWidth style={{ width: '100%', marginBottom: '1.25vh' }}>
                    <InputLabel id="demo-simple-select-label">Gas Units</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        defaultValue="m3"
                        label="Water Units"
                        value={units}
                        onChange={handleUnits}
                        MenuProps={{ disablePortal: true }}
                    >
                    <MenuItem value="m3">m<sup>3</sup></MenuItem>
                    <MenuItem value="usg">USG</MenuItem>
                    <MenuItem value="mcf">MCF</MenuItem>
                    <MenuItem value="ccf">CCF</MenuItem>
                    <MenuItem value="acf">acre-feet</MenuItem>
                    <MenuItem value="l">L</MenuItem>
                    </Select>
                </FormControl>
                
                <div className="field-row-full-mb">
                    <TextField fullWidth type="number" 
                        label="Gas Reading (m3)"
                        value={gas} 
                        error={gasErr !== ''}
                        helperText={gasErr}
                        onChange={handleGas} 
                        />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 

                <div className="field-row-full-mb">
                <TextField  
                    fullWidth 
                    id="outlined-basic" 
                    label="Total Gas Cost ($)" 
                    type="number" 
                    variant="outlined"
                    value={gasCost} 
                    onChange={handleGasCost} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 

                {props.reading.id &&
                <div className="field-row-full-mb">
                <TextField  
                    fullWidth 
                    id="outlined-basic" 
                    label="HDD Baseline" 
                    type="number" 
                    variant="outlined"
                    value={hdd} 
                    onChange={handleHdd} 
                    style={{ width: '100%', marginBottom: '1.25vh' }} />

                    <Tooltip title={costTip} className="field-tooltip-col" slotProps={{popper: {sx: { zIndex: 1000000 }}}}>
                        <IconButton sx={{ m: 1 }} className="help-icon-btn">
                            <HelpCenter/>
                        </IconButton>
                    </Tooltip>
                </ div> 
                }
           </>
        }
            </Modal.Body>
            <Modal.Footer>
            <div className="field-row-full">
                    {page > 1 && <IconButton aria-label="site-create-back" onClick={() => setPage(page - 1)}>
                        <ArrowBackIcon />
                    </IconButton>}

                    <div className="field-spacer-lg"></div>

                    <IconButton aria-label="site-create-next" onClick={() => incrementPage()}>
                        {page < 2 ? <ArrowForwardIcon /> : <DoneIcon />}
                    </IconButton>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default GasModal;